<template>
  <div class="contactUs">
    <el-dialog
      v-model="dialogVisible"
      append-to-body
      class="contact-us-dialog"
      :show-close="false"
      align-center
      @close="dialogVisible = false"
    >
      <div class="custom-wrapper">
        <div class="header flex justify-between align-center">
          <div class="cumtom-title">{{ props.title }}</div>
          <el-icon @click="dialogVisible = false"><CloseBold /></el-icon>
        </div>
        <slot></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { CloseBold } from '@element-plus/icons-vue'
const dialogVisible = ref(false)
const props = defineProps({
  title: {
    type: String,
    default: ''
  }
})

defineExpose({
  dialogSwitch(visible: boolean) {
    dialogVisible.value = visible
  }
})
</script>

<style lang="scss" scoped>
.contactUs {
  .header {
    padding: 10px 0 25px;
    cursor: default;

    .cumtom-title {
      color: #ffffff;
      font-size: 36px;
      font-weight: 600;
      line-height: 50px;
    }

    .el-icon {
      font-size: 24px;
      color: #fff;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: var(--primary-color);
      }
    }
  }
}

@media (max-width: 768px) {
  .contactUs .header .cumtom-title {
    font-size: 24px;
    line-height: 40px;
  }
}
</style>

<!-- append-to-body 后弹窗在 body 下，宽度样式需全局作用到 .contact-us-dialog -->
<style lang="scss">
.contact-us-dialog {
  padding: 0 !important;
  width: 75% !important;
  max-width: 1290px;
  background: #252c3d;

  .el-dialog__header {
    padding: 0 !important;
  }

  .el-dialog__body {
    padding: 40px;
  }

  // 与城市/服务/AQI 弹窗头部一致（append-to-body 需全局命中）
  .header {
    padding: 10px 0 25px;
    cursor: default;

    .cumtom-title {
      color: #ffffff;
      font-size: 36px;
      font-weight: 600;
      line-height: 50px;
    }

    .el-icon {
      font-size: 24px;
      color: #fff;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: var(--primary-color);
      }
    }
  }
}

@media (max-width: 768px) {
  .contact-us-dialog .header .cumtom-title {
    font-size: 24px;
    line-height: 40px;
  }
}

@media (max-width: 767px) {
  .contact-us-dialog {
    width: calc(100vw - 32px) !important;
    max-width: calc(100vw - 32px) !important;
    margin: 0 auto;

    .el-dialog__body {
      padding: 16px;
    }
  }
}
</style>
